import React from "react";
//import Layout from "../Layout/Layout";
const contactUs = () => {
	return(
	   <>
		    Contact Us
		</>
		
	
	
	
	);
}
export default contactUs;